import * as React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import Layout from 'src/components/organisms/Layout'
import Hero from 'src/components/organisms/Hero'
import SEO from 'src/utils/seo'

import {contact} from 'src/assets/images/backgrounds'

import type {ReactJSXElement} from '@emotion/react/types/jsx-namespace'

interface Props {
  heroContent: () => ReactJSXElement
  contactGrid: () => ReactJSXElement
  // contactForm: () => ReactJSXElement
}

const Contact = ({
  heroContent: HeroContent,
  contactGrid: ContactGrid,
}: // contactForm: ContactForm,
Props) => {
  return (
    <Layout>
      <SEO title="NCFX | Contact us" />
      <Hero backgroundFullWidth={contact}>
        <HeroContent />
      </Hero>
      <Box sx={{py: 10}}>
        <Container maxWidth="lg">
          <ContactGrid />
          {/* <ContactForm /> */}
        </Container>
      </Box>
    </Layout>
  )
}

export default Contact
